import { Fragment, FunctionComponent } from "react";
import FilterBottomRow from "./filter-bottom-row";
import {
  BlueBackground,
  StyledCol,
  StyledContainer,
  StyledRow,
} from "./filter.styles";
import { useAppState } from "modules/app/hook";
import { useFilterState } from "./hook";
import AttributeGroup from "modules/attribute-group/attribute-group";

const Filter: FunctionComponent<any> = () => {
  const appState = useAppState();
  const filterState = useFilterState();
  const { selectedOrganizationUnitData } = appState;

  if (!selectedOrganizationUnitData) {
    return null;
  }

  const renderFilters = () => {
    const { attributeGroups = [] } = selectedOrganizationUnitData;

    return (
      <Fragment>
        {attributeGroups.map((group: any) => (
          <StyledCol key={group.uuid}>
            <AttributeGroup group={group} />
          </StyledCol>
        ))}
      </Fragment>
    );
  };

  const { showFilter } = filterState;
  return (
    <BlueBackground>
      <StyledContainer>
        {showFilter && <StyledRow>{renderFilters()}</StyledRow>}
        <StyledRow>
          <StyledCol>
            <FilterBottomRow />
          </StyledCol>
        </StyledRow>
      </StyledContainer>
    </BlueBackground>
  );
};

export default Filter;
